import { useAtom } from 'jotai';

import { Trans } from '@lingui/react/macro';

import { VideaTypography } from '@/common-components/elements/VideaTypography/VideaTypography';
import { jumpToCurrentApptAtom } from '@/modules/patientList/atoms';
import { Switch } from '@repo/videa-components/src/ui/switch';

export const PreferenceScrollToCurrent = () => {
  const [jumpToCurrentAppt, setJumpToCurrenAppt] = useAtom(
    jumpToCurrentApptAtom,
  );
  const handlePrefChange = (checked: boolean) => {
    const newScrollToPreference = checked ? 'true' : 'false';
    setJumpToCurrenAppt(newScrollToPreference);
  };
  return (
    <div className="pane-section">
      <Switch
        checked={jumpToCurrentAppt === 'true'}
        onCheckedChange={handlePrefChange}
      />

      <VideaTypography variant="labelSmall">
        <Trans>Jump to the current patient when loading the patient list</Trans>
      </VideaTypography>
    </div>
  );
};
